export const navigateToWorkspaces = () => {
  window.location.assign(`${window.location.origin}/workspaces`);
};
